import { gql } from "@apollo/client";

export const PRODUCT_FRAGMENT = gql`
  fragment ProductPart on Product {
    id
    name
    url
    imgUrl
    reference
    siteId
    lastQuantity
    lastPrice
    priceOnly

    createdAt
  }
`;

export const PRODUCTS = gql`
  query ProductsQuery(
    $limit: Int!
    $offset: Int!
    $where: ProductsFiltersInput!
  ) {
    products(limit: $limit, offset: $offset, where: $where) {
      hasMore
      total
      results {
        ...ProductPart

        site {
          id
          name
        }
      }
    }
  }
  ${PRODUCT_FRAGMENT}
`;

export const CREATE_PRODUCT = gql`
  mutation CreateProductMutation($input: CreateProductInput!) {
    createProduct(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProductMutation($id: Int!, $input: UpdateProductInput!) {
    updateProduct(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const PRODUCT = gql`
  query ProductQuery($id: Int!) {
    product(id: $id) {
      ok
      error
      result {
        ...ProductPart

        site {
          id
          name
        }
      }
    }
  }
  ${PRODUCT_FRAGMENT}
`;
